/**
 * HP VRH — offer picker + add-to-cart, scoped to [data-hp-vrh] roots.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-hp-vrh]';
  var FADE_MS = 200;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseItems(opt) {
    var raw = opt.getAttribute('data-items');
    if (!raw) return null;
    try {
      var items = JSON.parse(raw);
      return Array.isArray(items) && items.length ? items : null;
    } catch (e) {
      return null;
    }
  }

  function openCart() {
    document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (
      window.Rebuy &&
      window.Rebuy.SmartCart &&
      typeof window.Rebuy.SmartCart.show === 'function'
    ) {
      window.Rebuy.SmartCart.show();
    } else {
      window.location.href = '/cart';
    }
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-hp-vrh-init') === 'true') return;
    root.setAttribute('data-hp-vrh-init', 'true');

    var photo = root.querySelector('.hp-vrh__photo');
    var frames = [].slice.call(root.querySelectorAll('.hp-vrh__photo-frame'));
    var opts = [].slice.call(root.querySelectorAll('.hp-vrh__opt'));
    var details = root.querySelector('.hp-vrh__details');
    var lists = [].slice.call(root.querySelectorAll('.hp-vrh__list'));
    var cta = root.querySelector('.hp-vrh__cta');
    var ctaPrice = root.querySelector('.hp-vrh__cta-price');
    var guar = root.querySelector('.hp-vrh__guarantee');
    var err = root.querySelector('.hp-vrh__err');
    var status = root.querySelector('[role="status"]');
    var swapTimer = null;
    var current = root.getAttribute('data-default-offer') || '';

    if (!opts.length) return;

    if (!current) {
      var preselected = opts.filter(function (b) {
        return b.getAttribute('aria-checked') === 'true';
      })[0];
      current = (preselected && preselected.getAttribute('data-opt')) || opts[0].getAttribute('data-opt');
    }

    function setPhoto(offerKey, animate) {
      if (!photo) return;

      var reduce = prefersReducedMotion();
      var apply = function () {
        frames.forEach(function (frame) {
          var on = frame.getAttribute('data-offer-key') === offerKey;
          if (on) {
            frame.classList.add('is-active');
          } else {
            frame.classList.remove('is-active');
          }
        });
        var activeOpt = opts.filter(function (b) {
          return b.getAttribute('data-opt') === offerKey;
        })[0];
        var label = activeOpt && activeOpt.getAttribute('data-label');
        if (label) photo.setAttribute('aria-label', label);
        photo.style.opacity = '1';
      };

      if (animate && !reduce) {
        photo.style.opacity = '0';
        window.clearTimeout(swapTimer);
        swapTimer = window.setTimeout(apply, FADE_MS);
      } else {
        window.clearTimeout(swapTimer);
        apply();
      }
    }

    function setDetailsHeight(offerKey, animate) {
      if (!details) return;
      var activeList = lists.filter(function (list) {
        return list.getAttribute('data-list') === offerKey;
      })[0];
      if (!activeList) return;

      var targetHeight = activeList.scrollHeight;

      if (!animate || prefersReducedMotion()) {
        details.style.transition = 'none';
        details.style.height = targetHeight + 'px';
        void details.offsetHeight;
        details.style.transition = '';
      } else {
        details.style.height = targetHeight + 'px';
      }
    }

    function select(offerKey, animate) {
      current = offerKey;

      opts.forEach(function (btn) {
        var on = btn.getAttribute('data-opt') === offerKey;
        btn.setAttribute('aria-checked', String(on));
        btn.tabIndex = 0;
      });

      lists.forEach(function (list) {
        list.setAttribute('aria-hidden', String(list.getAttribute('data-list') !== offerKey));
      });

      setDetailsHeight(offerKey, animate);

      var activeOpt = opts.filter(function (b) {
        return b.getAttribute('data-opt') === offerKey;
      })[0];

      if (activeOpt) {
        if (ctaPrice) ctaPrice.textContent = activeOpt.getAttribute('data-price') || '';
        if (guar) guar.textContent = activeOpt.getAttribute('data-guarantee') || '';
      }

      setPhoto(offerKey, animate);

      if (err) {
        err.classList.remove('is-visible');
        err.textContent = '';
      }
      if (status) status.textContent = '';
    }

    opts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        select(btn.getAttribute('data-opt'), true);
      });

      btn.addEventListener('keydown', function (e) {
        if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) === -1) return;
        e.preventDefault();
        var i = opts.indexOf(btn);
        var next =
          e.key === 'ArrowDown' || e.key === 'ArrowRight'
            ? opts[(i + 1) % opts.length]
            : opts[(i - 1 + opts.length) % opts.length];
        next.focus();
        select(next.getAttribute('data-opt'), true);
      });
    });

    if (cta) {
      cta.addEventListener('click', function () {
        var activeOpt = opts.filter(function (b) {
          return b.getAttribute('data-opt') === current;
        })[0];
        var items = activeOpt ? parseItems(activeOpt) : null;
        if (!items) return;

        cta.setAttribute('aria-busy', 'true');
        if (err) {
          err.classList.remove('is-visible');
          err.textContent = '';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add');
            return r.json();
          })
          .then(function () {
            if (status) status.textContent = 'Added to cart. Opening your cart.';
            openCart();
          })
          .catch(function () {
            if (err) {
              err.textContent = 'Something went wrong. Please try again.';
              err.classList.add('is-visible');
            }
          })
          .then(function () {
            cta.removeAttribute('aria-busy');
          });
      });
    }

    select(current, false);
  }

  function initAll(scope) {
    var roots;
    if (scope && scope.querySelectorAll) {
      if (scope.matches && scope.matches(ROOT_SELECTOR)) {
        roots = [scope];
      } else {
        roots = scope.querySelectorAll(ROOT_SELECTOR);
      }
    } else {
      roots = document.querySelectorAll(ROOT_SELECTOR);
    }

    for (var i = 0; i < roots.length; i++) {
      initRoot(roots[i]);
    }
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
